/* eslint-disable */
/**
 * 该文件是为了按需加载，剔除掉了一些不需要的框架组件。
 * 减少了编译支持库包大小
 *
 * 当需要更多组件依赖时，在该文件加入即可
 */
import Vue from 'vue'

import {
  MessageBox,
  Notification,
  Message
} from 'element-ui'

// import VueCropper from 'vue-cropper'

// Vue.use(Button)


Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message



// WEBPACK FOOTER //
// ./src/core/lazy_lib/components_use.js